module.exports = __webpack_public_path__ + "img/warn.9e390287.png";